<template>
  <div id="guide" class="login f-c-s">
    <div class="loginpage f-c-s f-d-c w-66 h-100">
      <div class="f-c-c w-100 h-15">
        <Navbar />
      </div>
      <div class="maincontent f-c-s f-d-c w-100 h-70">
      <b-img
        class="contentImg"
        :src="require(`@/assets/images/home/hint.png`)"
      ></b-img>
      <div class="helpContent f-c-c">
        چه بخواهید در یک کلاس آنلاین شرکت کنید، چه وبینار بگذارید و چه جلسه
        کاری، نکته مهم این است که ارتباطی امن و مقرون به صرفه داشته باشید.
        واداروم پلتفرم مناسب این کار را برایتان فراهم کرده است. واداروم به عنوان
        یک سرویس امن، با کیفیت و مقرون به صرفه برای برگزاری کلاس‌های آنلاین،
        جلسات آنلاین و وبینار معرفی شده است و خوشبختانه با استقبال مشتریان و
        سایر صاحب نظران مواجه شده است. تیم واداروم به صورت مستمر در حال ارتقای
        نرم‌افزاری و افزایش امکانات و کیفیت این محصول است و امید داریم که
        بتوانیم به عنوان یک محصول قابل اتکا و مفید، خدماتی در شأن مشتریانمان
        ارائه کنیم. واداروم محیطی تعاملی فراهم کرده که در این محیط مدرس یا
        میزبان جلسه، می‌تواند همزمان با صحبت از طریق وبکم و میکروفون، برای
        شرکت‌کننده‌ها فایل آپلود کند تا همزمان همه آن را ببینند، و در صورت لزوم
        برای تکمیل فایل با هم به طور زنده همکاری کنند.
      </div>
      </div>

      <div class="gapMaterial f-c-b w-100 h-15">
        <div class="text f-c-c">
          کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
          باشد.
        </div>
        <a
          data-v-efcdee58=""
          style="width: 80px; height: 80px"
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          ><img
            data-v-efcdee58=""
            referrerpolicy="origin"
            src="https://vadaroom.ec.iau.ir/img/logo_enamad.png"
            alt=""
            id="bjOij5apDKj7OdTL5Wi7"
            style="cursor: pointer; width: 100%; height: 100%"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Navbar from "@/components/LoginNavbar";
export default {
  name: "Guide",
  data() {
    return {};
  },
  created() {
        this.isShowNavFunction(3);
  },
  computed: {

  },
  components: {
    Navbar,
  },
  methods: {
    ...mapActions("gap", ["isShowNavFunction"]),
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
</style>